<template>
  <div>
    <vue-excel-xlsx :data="data" :columns="columns" :filename="'orçamentos-corretivas'" :sheetname="'sheetname'" class="btn btn-primary">
      Orçamentos Corretivas
    </vue-excel-xlsx>
  </div>
</template>

<script>
export default {
  data() {
    return {
      env: process.env,
      orcamentos: '',
      columns: [
        {
          label: 'chamado_id',
          field: 'chamado_id'
        },
        {
          label: 'sigla_estacao',
          field: 'sigla_estacao'
        },
        {
          label: 'codigo_ssp',
          field: 'codigo_ssp'
        },
        {
          label: 'uf',
          field: 'uf'
        },
        {
          label: 'valor_orcamento',
          field: 'valor_orcamento',
          dataFormat: this.priceFormat
        },
        {
          label: 'usuario_nome',
          field: 'usuario_nome'
        },
        {
          label: 'usuario_email',
          field: 'usuario_email'
        },
        {
          label: 'justificativa',
          field: 'justificativa'
        },
        {
          label: 'servico_id',
          field: 'servico_id'
        },
        {
          label: 'servico',
          field: 'servico'
        },
        {
          label: 'created_at',
          field: 'created_at'
        },
        {
          label: 'mes',
          field: 'mes'
        },
        {
          label: 'ano',
          field: 'ano'
        },
        {
          label: 'status',
          field: 'status'
        },
        {
          label: 'proprietario',
          field: 'proprietario'
        }
      ],
      data: []
    }
  },
  mounted: function () {
    this.getOrcamentosAprovados()
  },
  methods: {
    priceFormat(value) {
      return 'R$ ' + value
    },
    getOrcamentosAprovados() {
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/exportarOrcamentosAprovados`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.login.loginUsuario.token}`,
        },
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.orcamentos = response.data
          vm.formatarDados()
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true })
        }
      })
    },
    formatarDados() {
      this.orcamentos.forEach(element => {
        let dadosOrcamento = {
          chamado_id: element.chamado_id,
          sigla_estacao: element.sigla_estacao,
          codigo_ssp: element.codigo_ssp,
          uf: element.uf,
          valor_orcamento: element.valor_orcamento,
          usuario_nome: element.usuario_nome,
          usuario_email: element.usuario_email,
          justificativa: element.justificativa,
          servico_id: element.servico_id,
          servico: element.servico,
          created_at: element.created_at,
          mes: element.mes,
          ano: element.ano,
          status: element.status,
          proprietario: element.proprietario
        }
        this.data.push(dadosOrcamento)
      })
    }
  }
}
</script>

<style scoped>
button:hover {
  background-color: #6c757d;
}

/* button {
    background-color:#3c7fe4;
    color: white;
    margin: 1%;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:5px;
    padding-top:5px;
    border-style: none;
    border-radius: 5px;
    width: 160px;
    height: 50px;
  } */
</style>



// WEBPACK FOOTER //
// ExportOrcamentosAprovados.vue?f1c97c92